import RepOverallDealsSummaryContainer from 'containers/RepOverallDealsSummary'
import React from 'react'

const RepOverallDealsSummaryPage = () => <RepOverallDealsSummaryContainer />

export default RepOverallDealsSummaryPage
